import { makeStyles, shorthands, tokens } from '@fluentui/react-components';

export const getActionsCardsStyles = makeStyles({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
    maxWidth: '1532px',
    flexDirection: 'row',
    justifyContent: 'start',
    ...shorthands.gap(tokens.spacingHorizontalL, tokens.spacingVerticalL),
  },
  cards: {
    ...shorthands.flex(1),
  },
});
